<template>
  <div id="Blank-Page">
    <v-container grid-list-xl fluid>
      <h1>บันทึกส่งพัสดุ</h1>
    </v-container>
    <v-container grid-list-xl fluid >
      <v-card class="ma-4 pa-4">
        <v-flex class="text-xs-center" >
           <div  class="text-lg-center"  >
 <img :src="imageUrl" height="150" v-if="imageUrl" />
          <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @change="onFilePicked"
          />
           </div>
         

          <v-btn fab icon  @click="pickFile">
            <v-icon color="error" title="เลือกรูป">camera_alt</v-icon>
          </v-btn>
          <!-- <v-btn flat icon color="error">
            <v-icon color="error" title="ยืนยันนำไปส่ง">camera_alt</v-icon>
          </v-btn> -->
        </v-flex>
        <v-select
          v-model="logistic_code"
          :items="logistics"
          item-value="code"
          item-text="name"
          label="บริษัทขนส่ง"
        ></v-select>
        <v-text-field v-model="tracking_no" label="หมายเลขจัดส่ง" data-vv-name="tracking_no"></v-text-field>


        <!-- <v-flex xs12 md6 class="text-sm-right">
          <v-btn fab large icon @click="submitPickParcel()">
            <v-icon large color="success" title="ยืนยันนำไปส่ง">send</v-icon>            
          </v-btn>
          <div>ยืนยันนำไปส่ง</div>
        </v-flex> -->
        <v-card-actions>
                <v-btn flat icon :to="{ name: 'dropparcel' }" >
                  <v-icon color="error" title="กลับ">reply</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  icon large
                  @click="submitPickParcel()"
                >
                  <v-icon large color="success" title="ยืนยันนำไปส่ง">send</v-icon>
                </v-btn>
              </v-card-actions>
      </v-card>
    </v-container>
    <v-container grid-list-xl fluid>List Parcel</v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EmployeeService from "@/services/EmployeeService";
import PackShipService from "@/services/PackShipService";
import authen from "@/store/modules/authen";

export default {
  name: "submitdropparcel",
  metaInfo: {
    title: "Submit Drop Parcel"
  },
  components: {
    // VWidget,
    // MiniStatistic,
    // VCircle,
    // ProfileCard,
    // CircleStatistic,
    // LinearStatistic,
    // BoxChart
  },
  data: () => ({
    logistic_code: "",
    logistics: [],
    tracking_no: "",
    imageUrl: "",
    imageFile: "",
    parcel_list: ""
  }),
  computed: {},
  methods: {
    ...mapActions("app", ["setTitleText"]),
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageUrl = "";
      }
    },
    async fetcchTransport() {
      await EmployeeService.getTransport().then(res => {
        if (res.success) {
          //console.log(res);
          this.logistics = res.transports;
        }
      });
    },
    async submitPickParcel() {
      await PackShipService.submitDropParcel(
        authen.state.userCode,
        this.parcel_list,
        this.logistic_code,
        this.tracking_no,
        this.imageUrl
      )
        .then(res => {
          if (res.success) {
            // redireict to drop pacel
            this.$router.push("/dropparcel");
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    }
  },
  mounted() {},
  created() {
    this.fetcchTransport();
    this.parcel_list = this.$route.params.roworderlist;
  }
};
</script>
